// 全网热瓜 栏目内容数据（时间线复盘 · 反转盘点 · 当事人回应 · 话题专区 · FAQ）

export interface TimelineNode {
  date: string;
  time: string;
  type: "start" | "mid" | "turn" | "result";
  title: string;
  desc: string;
}

export const flagshipTimeline: TimelineNode[] = [
  {
    date: "09.01",
    time: "10:20",
    type: "start",
    title: "事件发酵：博主连发三条视频实名开撕",
    desc: "探店博主「老杨逛吃」被同行以三条对比视频实名指控脚本与运镜高度雷同，话题火速冲上热搜前排。",
  },
  {
    date: "09.02",
    time: "09:40",
    type: "mid",
    title: "围观升级：粉丝团扒出三年期同款模板",
    desc: "支持双方粉丝陆续翻出近三年多期视频进行逐帧对比，争论焦点从「风格借鉴」转向「整段照搬」。",
  },
  {
    date: "09.03",
    time: "15:10",
    type: "turn",
    title: "第一次反转：疑似「原创方」实为早期翻拍",
    desc: "有网友指出指控方的早期视频同样存在借鉴他人之处，所谓「原创模板」本身来源存疑，舆论风向出现摇摆。",
  },
  {
    date: "09.04",
    time: "22:30",
    type: "mid",
    title: "平台介入：官方对涉事账号进行限流处理",
    desc: "平台侧对双方账号同步做出限流与原创度复核处理，并要求在一周内提交创作过程说明材料。",
  },
  {
    date: "09.06",
    time: "08:50",
    type: "result",
    title: "最新进展：博主本人发布万字长文回应",
    desc: "「老杨逛吃」首次发声，承认部分灵感参考但否认整段照搬，并附上分镜草稿与创作日志，事件进入核对阶段。",
  },
];

export interface ReversalItem {
  tag: string;
  title: string;
  status: "已实锤" | "反转" | "待核" | "告一段落";
  summary: string;
}

export const reversalList: ReversalItem[] = [
  {
    tag: "售假风波",
    title: "「阿哲严选」从售假到送检合格",
    status: "二次反转",
    summary: "从网友爆料售假到品牌方维权，再到第三方送检合格、平台判罚不变，短短五日经历两轮攻守互换。",
  },
  {
    tag: "解约纠纷",
    title: "歌手解约：从「单方面」到「协商中」",
    status: "告一段落",
    summary: "经纪公司最初措辞严厉称艺人单方面解约，工作室摆出合同条款后，双方态度转为协商，热搜热度随之回落。",
  },
  {
    tag: "打投乱象",
    title: "应援打投从「粉丝自发」到「官方点名」",
    status: "已实锤",
    summary: "争议视频最初被认定为粉丝自发行为，媒体与机构点名后，后援会紧急公告整改并暂停相关应援活动。",
  },
];

export interface ResponseItem {
  name: string;
  role: string;
  time: string;
  content: string;
}

export const responseList: ResponseItem[] = [
  {
    name: "阿哲严选",
    role: "带货主播 · 涉事方",
    time: "09.06 09:12",
    content: "「送检结果已经公示，我们对产品品质有底气。但我们也尊重平台规则，接下来会用完整证据链与平台沟通，不会回避问题。」",
  },
  {
    name: "老杨逛吃",
    role: "探店博主 · 被指控方",
    time: "09.06 08:50",
    content: "「坦率说，早期视频确实参考过别人的节奏。但说我整段照搬，我不能接受。分镜草稿和创作日志已经发出来了，欢迎大家核对。」",
  },
  {
    name: "星澜传媒",
    role: "经纪公司 · 涉事方",
    time: "09.05 22:05",
    content: "「感谢歌迷关心。双方并未就版权与分成达成一致，目前进入正常协商程序，最终结果以官方公告为准，请大家理性看待。」",
  },
];

export interface TopicItem {
  name: string;
  desc: string;
  count: string;
  read: string;
}

export const topicList: TopicItem[] = [
  { name: "带货翻车", desc: "售假、品质争议与售后维权现场", count: "128条热瓜", read: "3421万热度" },
  { name: "明星解约", desc: "合约纠纷、自由身与版权博弈", count: "96条热瓜", read: "2860万热度" },
  { name: "抄袭争议", desc: "内容搬运、借鉴边界与原创鉴定", count: "204条热瓜", read: "5127万热度" },
  { name: "塌房现场", desc: "人设崩塌、翻车道歉与脱粉回踩", count: "83条热瓜", read: "2196万热度" },
  { name: "娱乐圈内幕", desc: "剧组路透、资源争夺与团队博弈", count: "67条热瓜", read: "1783万热度" },
  { name: "素人爆火", desc: "一夜走红、人红是非多与争议缠身", count: "112条热瓜", read: "4090万热度" },
];

export interface FaqItem {
  q: string;
  a: string;
}

export const faqList: FaqItem[] = [
  {
    q: "「全网热瓜」是怎么保证事件信息准确、不传谣的？",
    a: "我们只汇总已有公开信源的信息，包括官方公告、当事人或代表方公开声明、平台处理结果，并标注每则内容的时间戳与来源性质，不做主观定性。对尚无定论的部分会明确标注「待核」或「持续发酵」。",
  },
  {
    q: "我该如何判断一条热瓜是「反转」还是「实锤」？",
    a: "看证据链是否闭环与是否被权威方确认。我们会在每起事件的时间线中标注节点类型：发酵、中间、反转、结果，只有多方信息相互印证并由当事人或官方确认的内容才会标注为「已实锤」或「告一段落」。",
  },
  {
    q: "更新频率是怎样的？订阅推送能及时收到消息吗？",
    a: "编辑部会对热搜事件保持实时追踪，重要节点通常在事件发生后数小时内更新。订阅推送后，您会在关键进展更新时收到邮件提醒，避免错过反转与当事人回应。",
  },
  {
    q: "报道会偏向某一方当事人吗？",
    a: "不会。我们对涉事各方均一视同仁，会完整保留事件中各方的公开回应，让读者自行判断。为避免偏颇，稿件会刻意平衡呈现多角度信息，不做预设立场。",
  },
  {
    q: "如果我掌握了某起事件的线索，可以投稿吗？",
    a: "欢迎提供有价值的公开线索。请在页面底部订阅区留下联系方式并附上线索说明，编辑会进行信源核实，只有来源清晰、可交叉验证的内容才会被采用，匿名恶意举报将不予受理。",
  },
];